<template>
  <div>
    <b-form-checkbox
      id="select-all-search-permissions"
      v-model="allSelected"
      name="select-all-search-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item>
        <div class="row">
          <div
            v-for="(channel, index) in channels"
            :key="index"
            class="col-4"
          >
            <b-form-checkbox
              :id="`search-channel-${index}`"
              v-model="itemData.SearchChannel"
              :name="`${channel.Channel}`"
              class="mt-1 text-capitalize"
              switch
              :value="channel.Channel"
            >
              Channel {{ channel.Channel + 1 }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useArraySelectAllSwitch } from "./useSelectAllSwitch";

export default {
  props: {
    channels: {
      type: Array
    },
    itemData: {
      type: Object
    }
  },
  setup(props) {
    //COMPOSABLES
    // Getter: the channels arrive from the DVR after the form opens.
    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "SearchChannel",
      () => props.channels.map(channel => channel.Channel)
    );

    return { allSelected }
  }
}
</script>
